import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Sidebar from "./Sidebar";

const StandardSidebar = ({ t }) => (
	<Sidebar className="d-flex flex-column w-100">
		<p className="h5 mb-3">{t("sidebar.title")}</p>
		<ul className="mb-auto checklist">
			<li className="mb-4">{t("sidebar.list.one")}</li>
			<li className="mb-4">{t("sidebar.list.two")}</li>
			<li className="mb-4">{t("sidebar.list.three")}</li>
			<li className="mb-4">{t("sidebar.list.four")}</li>
		</ul>
	</Sidebar>
);

StandardSidebar.propTypes = {
	t: PropTypes.func,
};

export default translate()(StandardSidebar);
